module.exports = __webpack_public_path__ + "media/img/pages/companies/axpo-4e6ccbf10b2b6a15ebd2dcd1f3a0133c.png";